export default "__VITE_ASSET__CX0$DZQ8__"